
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';
  import TagService from '@/services/TagService';
  import { autoComplete } from '@/utils/Util';

  export default Vue.extend({
    name: 'TagFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'label', 'attributes', 'mandatory', 'always', 'multi', 'small'],
    data: (_this: any): any => ({
      rules: [
          (v: any) => !!v || _this.requiredError
      ],
      localTag: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      menu: false,
      loading: false,
      tags: [],
    }),
    created() {
      this.getTags();
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localTag;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      },
      autoComplete,
      getTags() {
        this.tags = [];
        this.loading = true;

        TagService.getAllCollectionPages(this.currentTenant).then((tags: any[]) => {
            this.loading = false;
            this.tags = tags;
        }).catch((err: any) => {
            console.log(err, err.response);
            this.loading = false;
        });
      },
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localTag = this.localFilters[this.attributes['value']];
      },
      menu() {
        if(!this.menu) {
          this.localTag = this.localFilters[this.attributes['value']];
        }
      },
      currentTenant() {
        this.tags = [];
        this.localFilters = { ...this.value }; // TODO
        this.getTags();
      }
    },
    computed: {
      filterRepr(): any {
        const raw = this.localFilters[this.attributes['value']];
        if (!raw) return '';
        if (this.multi) {
          return (raw as any[]).map((uuid: any) => {
            const found = this.tags.find((t: any) => t.uuid === uuid);
            return found ? found.name : uuid;
          }).join(', ');
        }
        const found = this.tags.find((t: any) => t.uuid === raw);
        return found ? found.name : raw;
      },
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localTag)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
    }
  })
